const MemberRejectionReportActionTypes = {
	/********* FETCH MEMBER REJECTION REPORT START ********************* */
	FETCH_MEMBER_REJECTION_REPORT_START: 'fetch_member_rejection_report_start',
	FETCH_MEMBER_REJECTION_REPORT_SUCCESS: 'fetch_member_rejection_report_success',
	FETCH_MEMBER_REJECTION_REPORT_FAILURE: 'fetch_member_rejection_report_failure',
	FETCH_MEMBER_REJECTION_REPORT_RESPONSE_RESET: 'fetch_member_rejection_report_response_reset',
	FETCH_MEMBER_REJECTION_REPORT_RESPONSE_CHANGED:
		'fetch_member_rejection_report_response_changed',
	/********* FETCH MEMBER REJECTION REPORT END ********************* */

	/********* EXPORT MEMBER REJECTION REPORT START ********************* */
	EXPORT_MEMBER_REJECTION_REPORT_START: 'export_member_rejection_report_start',
	EXPORT_MEMBER_REJECTION_REPORT_SUCCESS: 'export_member_rejection_report_success',
	EXPORT_MEMBER_REJECTION_REPORT_FAILURE: 'export_member_rejection_report_failure',
	EXPORT_MEMBER_REJECTION_REPORT_RESPONSE_RESET: 'export_member_rejection_report_response_reset',
	EXPORT_MEMBER_REJECTION_REPORT_RESPONSE_CHANGED:
		'export_member_rejection_report_response_changed',
	/********* EXPORT MEMBER REJECTION REPORT END ********************* */

	/********* FETCH MEMBER REJECTION COUNT START ********************* */
	FETCH_MEMBER_REJECTION_REASON_COUNT_START: 'fetch_member_rejection_reason_count_start',
	FETCH_MEMBER_REJECTION_REASON_COUNT_SUCCESS: 'fetch_member_rejection_reason_count_success',
	FETCH_MEMBER_REJECTION_REASON_COUNT_FAILURE: 'fetch_member_rejection_reason_count_failure',
	FETCH_MEMBER_REJECTION_REASON_COUNT_RESPONSE_RESET:
		'fetch_member_rejection_reason_count_response_reset',
	FETCH_MEMBER_REJECTION_REASON_COUNT_RESPONSE_CHANGED:
		'fetch_member_rejection_reason_count_response_changed',
	/********* FETCH MEMBER REJECTION COUNT END ********************* */
};
export default MemberRejectionReportActionTypes;
